import * as React from 'react';
import { BodySecondary } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { FacetOption as FacetOptionType } from '@/types/FacetOption';
import ActionText from '@liveauctioneers/caterwaul-components/lib/ActionText/ActionText';
import styled from 'styled-components';

type Props = {
    linkText: any;
    onChange: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    option: FacetOptionType;
};

const SelectedCountry = ({ linkText, onChange, option }: Props) => (
    <StyledSelectedCountry>
        <BodySecondary>{option.name}</BodySecondary>
        <StyledChangeCountryLink>
            <StyledViewMore onClick={onChange}>
                <BodySecondary>{linkText}</BodySecondary>
            </StyledViewMore>
        </StyledChangeCountryLink>
    </StyledSelectedCountry>
);

export default React.memo<Props>(SelectedCountry);

const StyledSelectedCountry = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    cursor: default;
`;

const StyledChangeCountryLink = styled.div`
    margin-left: 10px;
`;

const StyledViewMore = styled(ActionText)`
    cursor: pointer;
    margin-top: 4px;
    text-decoration: none;
`;
